import i18n, { TOptions, changeLanguage as changeLanguageI18n, t } from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from 'stylewhere/translations/en'
import it from 'stylewhere/translations/it'
import fr from 'stylewhere/translations/fr'
import es from 'stylewhere/translations/es'
import zh from 'stylewhere/translations/zh'
import zh_cn from 'stylewhere/translations/zh_simplified'
import ja from 'stylewhere/translations/ja'
import br from 'stylewhere/translations/br'
import ro from 'stylewhere/translations/ro'

import { StorageKeyName } from './Storage' // import directly or fail

const resources = {
  en: { translation: en },
  it: { translation: it },
  fr: { translation: fr },
  es: { translation: es },
  zh: { translation: zh },
  zh_cn: { translation: zh_cn },
  ja: { translation: ja },
  br: { translation: br },
  ro: { translation: ro }
}

// eslint-disable-next-line import/no-named-as-default-member
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'it', 'fr', 'es', 'zh', 'zh_cn', 'ja', 'br', 'ro'],
    load: 'all',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: StorageKeyName('language'),
      convertDetectedLanguage: (lng: string) => {
        // remove quotes as our Storage module use JSON.stringify
        if (lng && lng.indexOf('"') !== -1) {
          lng = lng.replace(/"/g, '')
        }
        return lng
      }
    }
  })

////////////////////////////////////////////////////
// HACK: use languages auto-completion
////////////////////////////////////////////////////
interface TranslationCategory {
  [key: string]: string
}

let TRANSLATION_MAP = en

// replace object values with keys
Object.keys(en).forEach((catKey, idx) => {
  const subCat: TranslationCategory = {}
  Object.keys(en[catKey]).forEach((key) => {
    subCat[key] = `${catKey}.${key}`
  })

  if (idx === 0) {
    TRANSLATION_MAP = {} as typeof en
  }

  TRANSLATION_MAP[catKey] = subCat
})
export { TRANSLATION_MAP as T }
////////////////////////////////////////////////////

export const __ = (key: string, interpolationMap?: TOptions) => t(key, interpolationMap)

export const __UP = (key: string, interpolationMap?: TOptions) => t(key, interpolationMap).toUpperCase()

export const changeLanguage = (locale: string) => {
  changeLanguageI18n(locale)
}

export const getLanguage = () => i18n.language

export default i18n
